import BaseConnector, { serializeEntity } from "./baseConnector";
import { apiUrl, accessTokenKey, apiVersion } from "../config";
import apiPath from "../utils/apiPath";

export interface BackOfficeConnectorOptions {
  onlyBaseUrl?: boolean;
  customVersion?: string;
}

export default class BackOfficeConnector extends BaseConnector {
  constructor(options: BackOfficeConnectorOptions = { onlyBaseUrl: false }) {
    const versionPath = apiPath(options.customVersion ?? apiVersion);
    const url = options.onlyBaseUrl ? apiUrl : `${apiUrl}/${versionPath}`;
    super(url, accessTokenKey, serializeEntity);
  }

  static Factory() {
    return (options?: BackOfficeConnectorOptions) => new BackOfficeConnector(options);
  }
}
